"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.yesNoFieldToListField = void 0;
const migrations_1 = require("../../migrations/migrations");
const yes_no_field_helpers_1 = require("./yes-no-field.helpers");
function yesNoFieldToListField(fieldTo, fieldFrom) {
    const migratedField = (0, migrations_1.migrateBaseField)(fieldTo, fieldFrom);
    return {
        ...migratedField,
        params: {
            ...migratedField.params,
            display_format: "colored_pill",
            choices: (0, yes_no_field_helpers_1.yesNoChoices)(fieldFrom),
        },
    };
}
exports.yesNoFieldToListField = yesNoFieldToListField;
